import React from "react";
import ReactDOM from "react-dom/client";
import "@fontsource/open-sans-condensed/latin-ext-700.css";
import "@fontsource/open-sans-condensed/latin-700.css";



import App from "./App";

import { ChakraProvider } from "@chakra-ui/react";
import customTheme from "./utils/themes";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ChakraProvider theme={customTheme}>
      <App />
    </ChakraProvider>
  </React.StrictMode>
);